import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { BtnGroupWAStyle, ReportBox } from "../../../Theme";
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Area,
  AreaChart,
  ResponsiveContainer,
} from "recharts";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import moment from "moment";
import { DashboardGraphReport } from "../../../Apis/AuthApiServices";
const FilterButtons = [
  // {
  //   children: "Day",
  //   filterCode: "day",
  // },
  {
    children: "Week",
    filterCode: "week",
  },
  {
    children: "Month",
    filterCode: "month",
  },
  {
    children: "Year",
    filterCode: "year",
  },
  {
    children: "Total",
    filterCode: "max",
  },
];

export default function GraphReport() {
  const [selectedPeriod, setSelectedPeriod] = useState("max");
  const [sortedData, setSortedData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const currentDate = new Date();
  const filterDates = (filterCode: string) => {
    switch (filterCode) {
      // case "day":
      //   const filteredDates = sortedData
      //     .filter((item) => {
      //       const Dates = moment(item.Date).format("YYYY-MM-DD");
      //       return Dates === moment(currentDate).format("YYYY-MM-DD");
      //     })
      //     .map((d) => {
      //       const itemDate = moment(d.Date);
      //       return {
      //         ...d,
      //         Date: itemDate.format("DD"),
      //       };
      //     });
      //   setFilteredData(filteredDates);
      //   break;
      case "week":
        const past7Days = moment(currentDate).clone().subtract(7, "days");
        const filteredWeeks = sortedData
          .filter((item: any) => {
            const itemDate = moment(item.date);
            return (
              itemDate.isSameOrAfter(past7Days) &&
              itemDate.isSameOrBefore(currentDate)
            );
          })
          .map((d: any) => {
            const itemDate = moment(d.date);
            return {
              ...d,
              date: itemDate.format("MMMM-DD"),
            };
          });
        setFilteredData(filteredWeeks);
        break;
      case "month":
        const oneMonthAgo = moment(currentDate).clone().subtract(1, "months");
        const filteredMonth = sortedData
          .filter((item: any) => {
            const itemDate = moment(item.date);
            return (
              itemDate.isSameOrAfter(oneMonthAgo) &&
              itemDate.isSameOrBefore(currentDate)
            );
          })
          .map((d: any) => {
            const itemDate = moment(d.date);
            return {
              ...d,
              date: itemDate.format("MMMM-DD"),
            };
          });
        setFilteredData(filteredMonth);
        break;
      case "year":
        const oneYearAgo = moment(currentDate).clone().subtract(1, "years");
        const filteredYear = sortedData
          .filter((item: any) => {
            const itemDate = moment(item.date);
            return (
              itemDate.isSameOrAfter(oneYearAgo) &&
              itemDate.isSameOrBefore(currentDate)
            );
          })
          .map((d: any) => {
            const itemDate = moment(d.date);
            return {
              ...d,
              date: itemDate.format("YYYY-MM-DD"),
            };
          });
        setFilteredData(filteredYear);
        break;
      default:
        setFilteredData(sortedData);
        break;
    }
  };

  const legendFormat = (value: string) => {
    switch (value) {
      case "totalPrescriptionCount":
        return <span>Sent prescriptions</span>;
      case "erroredPrescriptionCount":
        return <span>Error prescriptions</span>;
      case "printPrescriptionCount":
        return <span>Print prescriptions</span>;
    }
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <Grid
          bgcolor={"white"}
          border={1}
          borderColor={"lightgray"}
          padding={3}
          borderRadius={1}
        >
          <Typography variant="subtitle2">{label}</Typography>
          {payload.map((item: any) => (
            <>
              {item?.dataKey === "totalPrescriptionCount" ? (
                <Grid container my={1}>
                  <Typography
                    color={item.color}
                    variant="body1"
                  >{`Sent prescriptions: ${item?.value}`}</Typography>
                </Grid>
              ) : item?.dataKey === "erroredPrescriptionCount" ? (
                <Grid container my={1}>
                  <Typography
                    color={item.color}
                    variant="body1"
                  >{`Error prescriptions: ${item?.value}`}</Typography>
                </Grid>
              ) : (
                <Grid container my={1}>
                  <Typography
                    color={item.color}
                    variant="body1"
                  >{`Print prescriptions: ${item?.value}`}</Typography>
                </Grid>
              )}
            </>
          ))}
        </Grid>
      );
    }

    return null;
  };

  const getReportGraphData = async () => {
    try {
      const params: any = new URLSearchParams();
      params.append("doctorId", localStorage.getItem("doctorId"));
      const result = await DashboardGraphReport(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        const dateFormatChange = result?.data?.response?.map((d: any) => {
          const itemDate = moment(d.date);
          return {
            ...d,
            date: itemDate.format("YYYY-MM-DD"),
          };
        });
        setSortedData(dateFormatChange);
        setFilteredData(dateFormatChange);
      } else {
        setSortedData([]);
        setFilteredData([]);
      }
    } catch (error) {
      setSortedData([]);
      setFilteredData([]);
    }
  };
  useEffect(() => {
    getReportGraphData();
  }, []);

  return (
    <Grid
      container
      item
      xs={12}
      spacing={1}
      alignItems="top"
      justifyContent="center"
    >
      <Grid item xs={12}>
        <Typography component="div" variant="subtitle1">
          Reports
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ReportBox>
          <BtnGroupWAStyle style={{ textAlign: "right", marginBottom: 10 }}>
            {FilterButtons.map((button) => (
              <YSButton
                color="secondary"
                children={button.children}
                variant={
                  selectedPeriod === button.filterCode
                    ? "contained"
                    : "outlined"
                }
                type="button"
                onClick={() => {
                  setSelectedPeriod(button.filterCode);
                  filterDates(button.filterCode);
                }}
                size="medium"
                className=""
              />
            ))}
          </BtnGroupWAStyle>
          <ResponsiveContainer width={"100%"} height={300}>
            <AreaChart
              width={560}
              height={300}
              data={
                filteredData.length > 0
                  ? filteredData
                  : [
                      {
                        date: "",
                        totalPrescriptionCount: 0,
                        erroredPrescriptionCount: 0,
                        printPrescriptionCount: 0,
                      },
                    ]
              }
              margin={{
                top: 5,
                right: 20,
                left: 20,
                bottom: 5,
              }}
            >
              <XAxis
                fontSize={13}
                tickMargin={5}
                dataKey="date"
                minTickGap={10}
              />
              <YAxis fontSize={13} />
              <Tooltip content={<CustomTooltip />} />
              <Legend formatter={legendFormat} />
              <Area
                type="monotone"
                dataKey="totalPrescriptionCount"
                stroke="#44799C"
                fill="#44799C"
                activeDot={{ r: 8 }}
                // dot={{ stroke: "#44799C" }}
              />
              <Area
                type="monotone"
                dataKey="erroredPrescriptionCount"
                stroke="#B50000"
                fill="#B50000"
                // dot={{ stroke: "#B50000" }}
              />
              <Area
                type="monotone"
                dataKey="printPrescriptionCount"
                stroke="#4DDBBC"
                fill="#4DDBBC"
                // dot={{
                //   stroke: "#4DDBBC",
                // }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </ReportBox>
      </Grid>
    </Grid>
  );
}
